import * as React from 'react';
import SVGIcon from '../../../../../../../../Cutesies/SVGIcon';

const CoachingIcon: React.FC = () => {
  return (
    <SVGIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2 2V6H3V7.4375L3.78125 6.92188L5.15625 6H7V7.5H10.7812L11.2969 8.01562C10.293 8.11914 9.5 8.96875 9.5 10C9.5 10.5566 9.73828 11.0586 10.1094 11.4219C9.44336 11.873 9 12.6426 9 13.5H10C10 12.6719 10.6719 12 11.5 12C12.3281 12 13 12.6719 13 13.5H14C14 12.6426 13.5566 11.873 12.8906 11.4219C13.2617 11.0586 13.5 10.5566 13.5 10C13.5 9.50195 13.3047 9.05469 13 8.70312V7.5H14V3H9.5V2H2ZM3 3H8.5V5H4.84375L4.71875 5.07812L4 5.5625V5H3V3ZM9.5 4H13V6.5H12V7.28125L11.3594 6.64062L11.2031 6.5H8V6H9.5V4ZM4.5 8C3.40039 8 2.5 8.90039 2.5 10C2.5 10.5566 2.73828 11.0586 3.10938 11.4219C2.44336 11.873 2 12.6426 2 13.5H3C3 12.6719 3.67188 12 4.5 12C5.32812 12 6 12.6719 6 13.5H7C7 12.6426 6.55664 11.873 5.89062 11.4219C6.26172 11.0586 6.5 10.5566 6.5 10C6.5 8.90039 5.59961 8 4.5 8ZM4.5 9C5.05859 9 5.5 9.44141 5.5 10C5.5 10.5586 5.05859 11 4.5 11C3.94141 11 3.5 10.5586 3.5 10C3.5 9.44141 3.94141 9 4.5 9ZM11.5 9C12.0586 9 12.5 9.44141 12.5 10C12.5 10.5586 12.0586 11 11.5 11C10.9414 11 10.5 10.5586 10.5 10C10.5 9.44141 10.9414 9 11.5 9Z"
        fill="#3E5B67"
      />
    </SVGIcon>
  );
};

export default CoachingIcon;
